import * as React from 'react';
import { Radio } from './Radio';
export var RadioGroup = function (props) {
    var name = props.name, value = props.value, defaultValue = props.defaultValue, options = props.options, disabled = props.disabled, error = props.error, onChange = props.onChange;
    var _a = React.useState(value !== null && value !== void 0 ? value : defaultValue), currentValue = _a[0], setCurrentValue = _a[1];
    React.useEffect(function () {
        if (value !== undefined) {
            setCurrentValue(value);
        }
    }, [value]);
    var handleChange = React.useCallback(function (event) {
        // If `value` from props, use Controlled State and skip
        // setting currentValue. Otherwise, use internal state
        var val = event.currentTarget.value;
        var final;
        if (value !== undefined) {
            // Coerce radio value into correct return type
            final = typeof value === 'string' ? val : Number(val);
        }
        else {
            final = val;
            setCurrentValue(final);
        }
        if (onChange !== undefined) {
            onChange(final);
        }
    }, [onChange]);
    return (React.createElement(React.Fragment, null, options.map(function (option) { return (React.createElement(Radio, { key: option.value, name: name, value: option.value, label: option.label, checked: option.value === currentValue, onChange: handleChange, disabled: disabled !== null && disabled !== void 0 ? disabled : option.disabled, error: error !== null && error !== void 0 ? error : option.error, help: option.help })); })));
};
//# sourceMappingURL=RadioGroup.js.map